import { useAppDispatch, useAppSelector } from "@/config/store";
import { Button } from "@/components/ui";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui";
import { IEdoCourseQuiz } from "@/shared/model/edo-course-quiz.model";
import { deleteEntity } from "@/shared/reducers/entities/edo-course-quiz.reducer";
import { EntityState } from "@/shared/reducers/reducer.utils";
import { useEffect } from "react";
import { Translate } from "react-jhipster";

interface IDeleteCourseQuizProps {
  courseQuiz: IEdoCourseQuiz;
  open: boolean;
  onClose: () => void;
}

const DeleteCourseQuiz = (props: IDeleteCourseQuizProps) => {
  const dispatch = useAppDispatch();
  const { updateSuccess } = useAppSelector<EntityState<IEdoCourseQuiz>>(
    (state) => state.edoCourseQuiz
  );

  const { courseQuiz, open, onClose: handleClose } = props;

  const confirmDelete = () => {
    dispatch(deleteEntity(courseQuiz.id));
  };

  useEffect(() => {
    if (open && updateSuccess) {
      handleClose();
    }
  }, [updateSuccess, open, handleClose]);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && handleClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            <Translate contentKey="entity.delete.title">
              Confirm delete operation
            </Translate>
          </DialogTitle>
        </DialogHeader>
        <p className="text-body text-[var(--color-mockup-text-mid)]">
          <Translate contentKey="edocendoApp.edoCourseQuiz.delete.question" />
        </p>
        <p className="text-body text-[var(--color-mockup-text-mid)]">
          Tutti i risultati verranno persi.
        </p>
        <DialogFooter className="gap-2 pt-4">
          <Button variant="outline" onClick={handleClose}>
            <Translate contentKey="entity.action.cancel">Cancel</Translate>
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            <Translate contentKey="entity.action.delete">Delete</Translate>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteCourseQuiz;
